// sessionInit.js
import { store } from "../redux/store";
import { setTimezone } from "../redux/globalDataSlice";

const API_LOGOUT_URL = import.meta.env.VITE_API_LOGOUT_URL;

function clearClientCookies() {
  const hostname = window.location.hostname;
  const domainParts = hostname.split(".");

  // Try exact host, default host, and wildcard domains (.example.com)
  const domains = [undefined, hostname];
  for (let i = 1; i < domainParts.length; i++) {
    domains.push("." + domainParts.slice(i).join("."));
  }

  const cookies = document.cookie.split(";");

  cookies.forEach((cookie) => {
    const eqPos = cookie.indexOf("=");
    const name = eqPos > -1 ? cookie.slice(0, eqPos).trim() : cookie.trim();
    if (!name) return;

    domains.forEach((domain) => {
      const domainAttr = domain ? `; domain=${domain}` : "";
      // Clear for root path as well as current window sub-path
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/${domainAttr}`;
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${window.location.pathname}${domainAttr}`;
    });
  });
}

export function getTokenFromUrl() {
  return new URLSearchParams(window.location.search).get("token");
}

// A readable proxy for "is there already a logged-in session on this device".
// q_auth_* cookies are HttpOnly and can't be read from JS, but q_session_chunk_1
// is not, and localStorage carries our own session markers either way.
// selectedTimezone is only ever set once a user has actually used the app
// (see AppLayout.jsx/Topbar.jsx), so it's a decent extra signal - it's
// always kept in sync with redux's copy (see globalDataSlice.js), so
// checking one is equivalent to checking both.
export function hasExistingSession() {
  console.log(localStorage.getItem("accessToken"),
    localStorage.getItem("signed-voucher"),
    localStorage.getItem("selectedTimezone"),
    document.cookie
      .split('; ')
      .map((row) => row.trim())
      .filter(Boolean).length > 0
  )
  return Boolean(
    localStorage.getItem("accessToken") ||
    localStorage.getItem("signed-voucher") ||
    localStorage.getItem("selectedTimezone") ||
    document.cookie
      .split('; ')
      .map((row) => row.trim())
      .filter(Boolean).length > 0
  );
}

export function clearTokenFromUrl() {
  const params = new URLSearchParams(window.location.search);
  params.delete("token");
  const newSearch = params.toString();
  window.history.replaceState(
    {},
    "",
    window.location.pathname + (newSearch ? `?${newSearch}` : "") + window.location.hash
  );
}

// Applies a new token, clearing whatever of the old session is reachable
// from JS. Note: q_auth_* is HttpOnly and belongs to the IDP/gateway - it
// can't be cleared from here without a backend/Keycloak change.
export function finalizeSession(token) {
  // clearClientCookies();
  localStorage.clear();
  sessionStorage.clear();
  store.dispatch(setTimezone(null));
  localStorage.setItem("signed-voucher", token);
  clearTokenFromUrl();
}

// Same logout used by the manual Logout button in AppDrawer.jsx.
export function logout() {
  localStorage.clear();
  window.location.href = `${API_LOGOUT_URL}?redirectUrl=${encodeURIComponent(window.location.href)}`;
}
